import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../index.css';
import '../features/design-system/tokens.css';

import { LaytApp } from './LaytApp';

/**
 * ВХОД ЛАЙТ-ПЕРЕПИСКИ `chat.opsmind.ru` (`s608`, п.17 владельца).
 *
 * ⛔ ОТДЕЛЬНЫЙ ВХОД, А НЕ ОТДЕЛЬНЫЙ ПРОЕКТ. Панель тянет за собой сто с лишним
 * экранов, боковое меню, редактор сайтов и телефонию — дежурному с телефона не
 * нужно ничего из этого. Здесь только то, без чего переписка не работает, а
 * сами компоненты переписки — те же самые, импортом из экрана обращений.
 *
 * ⛔ Оформление подключается САМО: токены темы объявлены под классом
 * `.ops-skin`, и без этих двух строк экран вышел бы нераскрашенным — не
 * сломанным на глаз, а просто чужим.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LaytApp />
  </StrictMode>,
);
